export const ERROR_CODE = {
  OK: 'ok',
  TOKEN_INVALID: 'INVALID_TOKEN',
  SUCCESS: 0,
  LOGOUT_CODE: ['9990001', '9990008'], // token不存在/token失效
  REFRESH_CODE: ['9990002'], // token 超时
  TOKEN_INVALID_LIST: ['INVALID_TOKEN', 'TOKEN_EXPIRED'], // token失效
};
